<div class="login-body">
    <div class="login-panel p-fluid">
        <p-messages [(value)]="errorMessages" [closable]="false"></p-messages>
        <div class="p-grid login-container" style="padding-bottom: 20px;">
            <div class="p-col-12 logo-container">
                <img src="assets/title_logo.png" class="morpheus-logo" />
            </div>
            <div class="p-col-12">
                <input type="email" autocomplete="off" class="p-inputtext p-corner-all p-state-default p-widget" [(ngModel)]="email"
                    placeholder="Email">
            </div>
            <div class="p-col-12">
                <input type="password" autocomplete="off" class="p-inputtext p-corner-all p-state-default p-widget" [(ngModel)]="password"
                    placeholder="Password" (keyup.enter)="onEnter($event)">
            </div>
            <div class="p-col-12 chkbox-container">
                <input type="checkbox" id="remember-me" [(ngModel)]="rememberme" />
                <label for="remember-me">Remember Me</label>
            </div>
            <div class="p-col-12 button-container">
                <button type="button" (click)="onLogin()" [disabled]="isLoggingIn" class="p-button green-btn raised-btn p-widget p-state-default p-corner-all p-button-text-icon-left">
                    <span class="p-button-icon-left p-c fa fa-fw fa-user" *ngIf="!isLoggingIn"></span>
                    <span class="p-button-icon-left p-c fa fa-fw fa-spinner fa-spin" *ngIf="isLoggingIn"></span>
                    <span class="p-button-text p-c">Sign In</span>
                </button>
            </div>
            <hr>
            <div class="p-col-12 button-container">
                <button type="button" (click)="loginWithSAML()" [disabled]="isLoggingIn" class="p-button green-btn raised-btn p-widget p-state-default p-corner-all p-button-text-icon-left">
                    <span class="p-button-icon-left p-c fa fa-fw fa-user" *ngIf="!isLoggingIn"></span>
                    <span class="p-button-icon-left p-c fa fa-fw fa-spinner fa-spin" *ngIf="isLoggingIn"></span>
                    <span class="p-button-text p-c">Corporate Login</span>
                </button>
            </div>
        </div>

        <div class="stripe"></div>
        <p style="margin-left: -17px;">Forgot your password?
            <a [routerLink]="['/forgotPassword']"> Reset here </a>
        </p>
        <div class="stripe"></div>
        <p style="margin-left: -17px;">Don't you have an account?
            <a [routerLink]="['/register']"> Register here </a>
        </p>
        <div class="stripe"></div>
    </div>
</div>